import {Expose} from 'class-transformer';

export class ScreeningApiModel {
  @Expose()
  screeningTimeFrom: string;

  @Expose()
  screeningTimeTo: string;
}
